import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_SERVICE_INTERVAL, SERVICE_INTERVAL_ERROR, UPDATE_SERVICE_INTERVAL
} from './types';

import { base_url } from './constants';

axios.defaults.baseURL = base_url;

//GET Service Types
export const getServiceInterval = () => async dispatch => {
    try {
        // dispatch({
        //     type: RESET_SERVICE_INTERVAL,
        // });
        const res = await axios.get('/api/service_interval/');

        dispatch({ type: GET_SERVICE_INTERVAL, payload: res.data })
    } catch (err) {
        dispatch({
            type: SERVICE_INTERVAL_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}

//UPDATE SERVICE INTERVAL 
export const updateServiceInterval = formData => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    try {
        const res = await axios.put('/api/service_interval/update', formData, config);
        dispatch({
            type: UPDATE_SERVICE_INTERVAL,
        });

        dispatch(setAlert('Service interval Updated', 'success'));

        getServiceInterval();
    } catch (err) {
        dispatch(setAlert(err.msg, 'danger'));
        // console.log(err);
        // const errors = err.response.data.errors;

        // if (errors) {
        //     errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        // }
        dispatch({
            type: SERVICE_INTERVAL_ERROR,
        });
    }
}